"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToHue = void 0;
var numeric_1 = require("../../../functions/numeric");
var round_to_int_1 = require("../../../functions/round-to-int");
var clamp359 = (0, numeric_1.clamp)(0, 359);
var numberToHue = function (x) { return clamp359((0, round_to_int_1.roundToInt)(x)); };
exports.numberToHue = numberToHue;
